import React from 'react';
import { Stack, Typography, Divider } from '@mui/material';
import { InsuranceLabelsByKey } from 'modules/financeProgram/types';
import { insuranceLabelsByKey } from 'modules/financeProgram/constants';
import { checkIfQuillValueIsEmpty, convertHtmlToDelta } from 'utils/quillUtils';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';
import { FinanceProgramForm } from '../../../../../schema';
import { ReadOnlyQuill } from '../../../../../../desking/ui/components/catalogDetails/ReadOnlyQuill';

interface Props {
  financeProgramFormValues: FinanceProgramForm['program'];
}

export const InsuranceCoveragePart = ({ financeProgramFormValues: program }: Props) => {
  const insuranceCoverageFormData = program.fifth.insuranceCoverage;

  return (
    <Stack gap="1rem">
      {Object.keys(insuranceLabelsByKey).map(key => {
        const typedKey = key as keyof InsuranceLabelsByKey;

        return (
          <RenderWithCondition condition={!checkIfQuillValueIsEmpty(insuranceCoverageFormData[typedKey])}>
            <Stack key={key}>
              <Typography color="textDisabled">{insuranceLabelsByKey[typedKey]}:</Typography>

              <ReadOnlyQuill value={convertHtmlToDelta(insuranceCoverageFormData[typedKey])} />

              <Divider sx={{ mt: 1 }} />
            </Stack>
          </RenderWithCondition>
        );
      })}
    </Stack>
  );
};
